module.exports = __webpack_public_path__ + "img/clock.5625bb3c.svg";